<template>
  <div class="user-list-box">
    
  </div>
</template>

<script type="text/ecmascript-6">
import { mapState, mapMutations } from 'vuex'
import service from '../../service/leftService.js'
import authorService from '../../service/authorityService'
export default {
  components: {

  },
  data() {
    return {
    
     
    }
  },
  computed: {
    ...mapState({
      nodeData: 'objectInfo'
    })
  },
  watch: {
  },
  created() {
   
  },
  mounted() {
    
  },
  methods: {
    
    
  }
}
</script>
<style scoped>
.user-list-box{
  width: 100%;
  height: 100%;
  background-color: #303235;
  }
</style>



// WEBPACK FOOTER //
// src/components/notebook/userManage.vue